import React, { Component } from 'react';
import {
    Grid, Paper, Typography, Button, Table, TableHead, TableBody, TableRow, TableCell,
    IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
    FormControl, InputLabel, Select, MenuItem, Box
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import axios from 'axios';
import CacheStorage from "../../utils/CacheStorage";
import { toast } from 'react-toastify';
import DivaLoader from "../../Containers/DivaLoader";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import { Link } from "react-router-dom";
import config from "../../config";

class BRSRConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            structures: [],
            openEditor: false,
            currentStructure: {
                id: null,
                card_id: '',
                structure_name: '',
                structure_type: 'Table', // Table or QA
                structure_nature: 'Fixed', // Fixed or Variable
                domain: '',
                sub_domain: '',
                structure_text: ''
            },
            cards: [], // Need to fetch cards to populate dropdown
            tabValue: 0,
            financialYear: ''
        };
    }

    componentDidMount() {
        this.fetchStructures();
        this.fetchCards();
    }

    fetchStructures = async () => {
        this.setState({ loading: true });
        try {
            const token = CacheStorage.getItem("userToken");
            const response = await axios.get(`${config.laravelBaseUrl}brsr/master/structures`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.status === 'success') {
                this.setState({ structures: response.data.data });
            }
        } catch (error) {
            console.error("Fetch Error", error);
            toast.error("Failed to load structures");
        } finally {
            this.setState({ loading: false });
        }
    };

    fetchCards = async () => {
        try {
            const token = CacheStorage.getItem("userToken");
            // NOTE: Using existing endpoint from BRSRReportController
            const response = await axios.get(`${config.laravelBaseUrl}brsr/cards`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.status === 'success') {
                this.setState({ cards: response.data.data });
            }
        } catch (error) { console.error(error); }
    };

    handleOpenEditor = (structure = null) => {
        if (structure) {
            this.setState({
                openEditor: true,
                currentStructure: { ...structure }
            });
        } else {
            this.setState({
                openEditor: true,
                currentStructure: {
                    id: null,
                    card_id: '',
                    structure_name: '',
                    structure_type: 'Table',
                    structure_nature: 'Fixed',
                    domain: '',
                    sub_domain: '',
                    structure_text: ''
                }
            });
        }
    };

    handleSave = async () => {
        const { currentStructure } = this.state;
        if (!currentStructure.structure_name || !currentStructure.card_id) {
            toast.error("Please fill required fields");
            return;
        }

        this.setState({ loading: true });
        try {
            const token = CacheStorage.getItem("userToken");
            const response = await axios.post(`${config.laravelBaseUrl}brsr/master/save`, currentStructure, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.status === 'success') {
                toast.success("Structure saved successfully");
                this.setState({ openEditor: false });
                this.fetchStructures();
            } else {
                toast.error(response.data.message || "Save failed");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error saving structure");
        } finally {
            this.setState({ loading: false });
        }
    };

    handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this structure?")) return;
        this.setState({ loading: true });
        try {
            const token = CacheStorage.getItem("userToken");
            // Changed POST to GET as per routes definitions if POST wasn't working or simple GET delete
            // Route says: Route::get('/brsr/master/delete/{id}', ...)
            const response = await axios.get(`${config.laravelBaseUrl}brsr/master/delete/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.status === 'success') {
                toast.success("Structure deleted");
                this.fetchStructures();
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Error deleting structure");
        } finally {
            this.setState({ loading: false });
        }
    };

    handleExport = async () => {
        const { financialYear } = this.state;
        if (!financialYear) {
            toast.error("Please select Financial Year");
            return;
        }
        this.setState({ loading: true });
        try {
            const token = CacheStorage.getItem("userToken");
            const response = await axios.get(`${config.laravelBaseUrl}brsr/export?financial_year=${financialYear}`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `BRSR_Report_${financialYear}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            toast.success("Report downloaded successfully");
        } catch (error) {
            console.error(error);
            toast.error("Export failed");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { loading, structures, openEditor, currentStructure, cards, tabValue, financialYear } = this.state;

        return (
            <>
                <DashboardHeader />
                <div id="wrapper">
                    <DashboardSidebar />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            {/* Breadcrumbs */}
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/reporting/dashboard">Reporting</Link>
                                </li>
                                <li className="breadcrumb-item active">Configuration</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                {loading && <DivaLoader />}

                                <Grid container alignItems="center" style={{ marginBottom: 20 }}>
                                    <Typography variant="h5">BRSR Configuration</Typography>
                                </Grid>

                                <Paper style={{ marginBottom: 20, padding: 15 }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Button
                                                variant={tabValue === 0 ? "contained" : "outlined"}
                                                color="primary"
                                                onClick={() => this.setState({ tabValue: 0 })}
                                            >
                                                Structures
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant={tabValue === 1 ? "contained" : "outlined"}
                                                color="primary"
                                                onClick={() => this.setState({ tabValue: 1 })}
                                            >
                                                Export
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>

                                {tabValue === 0 && (
                                    <>
                                        <Grid container justify="flex-end" style={{ marginBottom: 10 }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddIcon />}
                                                onClick={() => this.handleOpenEditor()}
                                            >
                                                Add Structure
                                            </Button>
                                        </Grid>
                                        <Paper>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>ID</TableCell>
                                                        <TableCell>Name</TableCell>
                                                        <TableCell>Type</TableCell>
                                                        <TableCell>Nature</TableCell>
                                                        <TableCell>Domain</TableCell>
                                                        <TableCell>Actions</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {structures.map(s => (
                                                        <TableRow key={s.id}>
                                                            <TableCell>{s.id}</TableCell>
                                                            <TableCell>
                                                                <Typography variant="subtitle2">{s.structure_text}</Typography>
                                                            </TableCell>
                                                            <TableCell>{s.structure_type}</TableCell>
                                                            <TableCell>{s.structure_nature}</TableCell>
                                                            <TableCell>{s.domain}</TableCell>
                                                            <TableCell>
                                                                <IconButton onClick={() => this.handleOpenEditor(s)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                                <IconButton onClick={() => this.handleDelete(s.id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Paper>
                                    </>
                                )}

                                {tabValue === 1 && (
                                    <Paper style={{ padding: 30 }}>
                                        <Typography variant="h6" gutterBottom>Export BRSR Report</Typography>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} sm={4}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Financial Year</InputLabel>
                                                    <Select
                                                        value={financialYear || ''}
                                                        onChange={(e) => this.setState({ financialYear: e.target.value })}
                                                    >
                                                        <MenuItem value="2023-2024">2023-2024</MenuItem>
                                                        <MenuItem value="2024-2025">2024-2025</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={this.handleExport}
                                                    disabled={!financialYear}
                                                >
                                                    Download Excel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                )}
                            </div>
                        </div>
                        <FooterComponent />
                    </div>
                </div>

                <Dialog open={openEditor} onClose={() => this.setState({ openEditor: false })} maxWidth="md" fullWidth>
                    <DialogTitle>{currentStructure.id ? 'Edit Structure' : 'New Structure'}</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Card / Section</InputLabel>
                                    <Select
                                        value={currentStructure.card_id}
                                        onChange={(e) => this.setState({ currentStructure: { ...currentStructure, card_id: e.target.value } })}
                                    >
                                        {cards.map(c => (
                                            <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Structure Name"
                                    value={currentStructure.structure_name}
                                    onChange={(e) => this.setState({ currentStructure: { ...currentStructure, structure_name: e.target.value } })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Question Text / Title"
                                    value={currentStructure.structure_text}
                                    onChange={(e) => this.setState({ currentStructure: { ...currentStructure, structure_text: e.target.value } })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        value={currentStructure.structure_type}
                                        onChange={(e) => this.setState({ currentStructure: { ...currentStructure, structure_type: e.target.value } })}
                                    >
                                        <MenuItem value="Table">Table</MenuItem>
                                        <MenuItem value="QA">QA</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Nature</InputLabel>
                                    <Select
                                        value={currentStructure.structure_nature}
                                        onChange={(e) => this.setState({ currentStructure: { ...currentStructure, structure_nature: e.target.value } })}
                                    >
                                        <MenuItem value="Fixed">Fixed</MenuItem>
                                        <MenuItem value="Variable">Variable</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="Domain"
                                    value={currentStructure.domain || ''}
                                    onChange={(e) => this.setState({ currentStructure: { ...currentStructure, domain: e.target.value } })}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    fullWidth
                                    label="Sub Domain"
                                    value={currentStructure.sub_domain || ''}
                                    onChange={(e) => this.setState({ currentStructure: { ...currentStructure, sub_domain: e.target.value } })}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setState({ openEditor: false })}>Cancel</Button>
                        <Button onClick={this.handleSave} color="primary" variant="contained">Save</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default BRSRConfiguration;
